module.exports = __webpack_public_path__ + "img/parodia.52068cea.png";